module.exports = __webpack_public_path__ + "media/images/mailer-interview-quality-55ce240e5c1bb9da473a5f76b9cfff05.png";